import { Card, CardContent, CardHeader, Divider, Link } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function AskActiveOnlinePaymentCard({ email }) {
    const { t } = useTranslation()

    return (
        <Card>
            <CardHeader title={t("Active online payment")} />
            <Divider />
            <CardContent>
                {t("If you would like to active online payment, you can contact us via")}
                <Link sx={{ ml: 1 }} href={`https://wa.me/966581849999?text=${t("activeOnlinePaymentMessage", { email })}`} target="_balnk">{t("WhatsApp")}.</Link>
            </CardContent>
        </Card>
    )
}
